import { render, staticRenderFns } from "./questionUpload.vue?vue&type=template&id=20e4c912&"
import script from "./questionUpload.vue?vue&type=script&lang=js&"
export * from "./questionUpload.vue?vue&type=script&lang=js&"
import style0 from "./questionUpload.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports